// AUTO-GENERATED by `npm run codegen:ui` - do not edit.
namespace $ {

export type easyreels_user_signoutMutationVariables = Exact<{ [key: string]: never; }>;


export type easyreels_user_signoutMutation = { __typename?: 'Mutation', signOut: { __typename?: 'SignOutPayload', redirectUrl: string } };


export function $easyreels_user_signout(opts?: { revalidate?: boolean }): easyreels_user_signoutMutation {
	return $easyreels_gql_user_request(`mutation easyreels_user_signout {
  signOut {
    redirectUrl
  }
}`, undefined, opts) as easyreels_user_signoutMutation
}

}
